/* @flow */
import React from 'react';
import Hit from '../Hit/Hit';
import type {ListingShape} from '../Hit/Hit';

type Props = {
    listingData: ListingShape,
    isDatelessSearch?: boolean,
    index: number
};

export default function ExpandedGroupHitPlaceholder({
    listingData,
    index
}: Props) {
    return (
        <div className={'ExpandedGroupHitPlaceholder'}>
            <div className={'ExpandedGroupPlaceholder__hit'}>
                <Hit listing={listingData} index={index} hitIndex={index} />
            </div>
            <div className={'ExpandedGroupHitPlaceholder__overlay'} />
        </div>
    );
}
